import {
  faArrowRightArrowLeft,
  faArrowTrendUp,
  faChevronRight,
  faPlus,
} from '@fortawesome/pro-solid-svg-icons'
import { Icon, Pill, Separator, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'

const additionalAccounts = [
  {
    title: 'Savings Account',
    apy: '1% APY',
    tagline: 'Save toward your next milestone',
  },
  {
    title: 'Tax Account',
    apy: 'Up to 2.5% APY',
    tagline: 'Avoid tax season surprises',
  },
  {
    title: 'Other Account',
    apy: 'Up to 2.5% APY',
    tagline: 'Organize funds for any purpose',
  },
]

export const BankingAccountsPreview = () => (
  <div
    aria-hidden
    className="flex flex-col gap-3 rounded-3xl bg-gradient-yellow p-3 sm:p-4"
  >
    <div className="rounded-2xl border border-neutral-200 bg-neutral-0 p-4">
      <div className="flex items-center gap-3">
        <Icon
          icon={faArrowRightArrowLeft}
          backgroundClassName="bg-neutral-50"
          backgroundStyle="circle"
          size="sm"
          color="text-neutral-600"
        />
        <Text variant={TypographyStyles.BODY_SM} className="flex-1">
          Checking · 1234
        </Text>
        <Icon icon={faChevronRight} size="sm" color="text-neutral-400" />
      </div>
      <Separator className="my-4" />
      <div className="flex flex-col items-center gap-1">
        <Text variant={TypographyStyles.BODY_XS} color={TextColors.MUTED}>
          Available Balance
        </Text>
        <Text variant={TypographyStyles.DISPLAY_XS} color={TextColors.HEADER}>
          $9,283<span className="text-xl">.12</span>
        </Text>
        <div className="flex items-center gap-1.5">
          <Icon
            icon={faArrowTrendUp}
            backgroundClassName="bg-green-0"
            backgroundStyle="circle"
            size="2xs"
            color="text-green-100"
          />
          <Text variant={TypographyStyles.LABEL_SM} color={TextColors.GREEN}>
            1% APY
          </Text>
        </div>
      </div>
    </div>

    {additionalAccounts.map((account) => (
      <div
        key={account.title}
        className="flex items-center gap-3 rounded-2xl border border-neutral-200 bg-neutral-0 p-4"
      >
        <Icon
          icon={faPlus}
          backgroundClassName="bg-neutral-50"
          backgroundStyle="circle"
          size="sm"
          color="text-neutral-600"
        />
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <Text variant={TypographyStyles.LABEL_MD} color={TextColors.HEADER}>
              {account.title}
            </Text>
            <Pill
              variant="secondary"
              color="green"
              size="sm"
              uppercase={false}
              className="bg-neutral-25 text-green-100"
            >
              {account.apy}
            </Pill>
          </div>
          <Text variant={TypographyStyles.BODY_XS} color={TextColors.MUTED}>
            {account.tagline}
          </Text>
        </div>
        <Icon icon={faChevronRight} size="sm" color="text-neutral-400" />
      </div>
    ))}
  </div>
)
